module.exports = __webpack_public_path__ + "images/line_lp/section1-lead-text-bottom-image_51b8aba88fcbbb4ef014871840918407.png";